/* eslint-disable */
import React from "react";
import BaseSimpleTargetAI from "./target-configurator/target-form-config/base-simple-target/base-simple-target-ai";
import { buildCancelledResponse } from "../utils/hitl-cancel";

export interface ShowBasicTargetFormToolProps {
    args: { componentName: string; appName: string };
    respond?: (result: string) => void;
}

export const ShowBasicTargetFormTool: React.FC<ShowBasicTargetFormToolProps> = ({ args, respond }) => {
    const handleSave = (data: Record<string, any>) => {
        respond?.(JSON.stringify({ status: "saved", properties: data }));
    };

    const handleCancel = () => respond?.(buildCancelledResponse());

    return (
        <BaseSimpleTargetAI
            componentID={args.componentName}
            appName={args.appName}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
};
